/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */

export function defineRegister (i18n) {
  i18n.register = {}
  i18n.register.invalid_passwd = 'Mot de passe invalide'
}
